module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_55.12f70cd6.jpg";